// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '../../../../../elements/Modal/Modal';
import buttonStyle from '../../../../../assets/styles/button.scss';
import CourierInfo from '../../../../order/Purchase/components/CourierInfo/CourierInfo';

import style from './CourierAddressModal.scss';

import type {LocalValuesState} from '../../../../local-values/duck';
import type {Courier, User} from '../../../../../entities';
import type {ItemsByStore} from "../../../QuoteStep/components/QuoteSummary/QuoteSummary";

type Props = {
  open: boolean;
  handleClose: () => any;
  localValues: LocalValuesState;
  courier: Courier;
  days?: number;
  servicesCost: number;
  user?: User;
  summaryData?: { [string]: number | string | ItemsByStore[] };
};

export default function CourierAddressModal(props: Props) {
  const {open, handleClose, localValues, user, courier, days, servicesCost, summaryData} = props;

  const items = (<div>
    <p className={style.itemsSubtitle}>Compra de los siguientes enlaces:</p>
    {summaryData.itemsByStores.map((g, i) =>
      g.items.map((item, x) => {
        let rUrl = item.url;
        if (URL && item.url.includes('amazon')) {
          const u = new URL(item.url);
          rUrl = `${u.origin}${u.pathname}`;
        }
        return (<a key={`item-${i}-${x}`} target="_blank" href={rUrl} className={style.itemLink}>{item.name}</a>)
      })
    )}
    <br/>
  </div>);

  return (
    <Modal open={open}
           handleClose={handleClose}
           width={454}
           height={716}
           gray>
      <div className={style.courierAddressModal}>
        <h3 className={style.title}>Información importante</h3>
        <p className={style.text}>
          Recuerda que debes comprar los productos y enviarlos a nuestra dirección en USA antes de hacer el pago en
          Qempo.
        </p>
        {items}
        <CourierInfo localValues={localValues}
                     user={user}
                     courier={courier}
                     days={days}
                     servicesCost={servicesCost}/>
        <br/>
        <button type="button"
                onClick={handleClose}
                className={classNames(buttonStyle.btn,
                  buttonStyle.lightBlue,
                  style.button)}>
          Continuar
        </button>
      </div>
    </Modal>
  );
}

CourierAddressModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  localValues: PropTypes.object.isRequired,
  courier: PropTypes.object.isRequired,
  days: PropTypes.number,
  servicesCost: PropTypes.number.isRequired,
  user: PropTypes.object,
  summaryData: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/components/CourierAddressModal/CourierAddressModal.jsx